import styled from "styled-components";

export const HabilitiesContainer = styled.section`
    height:auto;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    background:#111221;
    
`;
export const HabilitiesWrapper = styled.div`
    max-width:1200px;
    margin:0 auto;
    display:grid;
    grid-template-columns: repeat(4,auto);
    align-items:center;
    grid-gap:1rem;
    @media screen and (max-width:1000px){
        grid-template-columns: repeat(2,auto);
        grid-template-rows: auto auto;
        padding:0px !important;
    }
    @media screen and (max-width:768px){
        grid-template-columns: repeat(2,auto);
        grid-template-rows: auto auto;
    }
`;

export const HabilitiesCard = styled.div`
    background:#000014;
    display:flex;
    flex-direction:column;
    justify-content:start;
    align-items:center;
    box-shadow: -2px 2px 26px -1px rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    width:17rem;
    padding:30px;
    transition: all 0.2s ease-in-out;
    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
    }
    @media screen and (max-width:600px){  
        padding: 7px;
        width: 10rem;
    }
`;

export const HabilitiesIcon = styled.div`
    font-size:3rem;
    margin-bottom: 10px;
    display:block;
    color:#ca9f9f;
    @media screen and (max-width:600px){
        font-size:2.5rem;
        margin-top:1rem;
    }
`;

export const HabilitiesH1 = styled.h2`
    font-size:2rem;
    font-weight:400 !important;
    color:#E8175D;
    margin-top:10rem;
    margin-bottom:64px;
    @media screen and (max-width:600px){
        font-size:2rem;
        margin-top:1rem;
        margin-bottom:2rem;
    }
`;

export const HabilitiesH2 = styled.h3`
    font-size:1.5rem; 
    color:#E8175D;
    font-weight:400 !important;
    text-transform:uppercase;
    @media screen and (max-width:600px){
        font-size:1rem;
        margin-bottom: 1rem;
    }
`;
export const HabilitiesH22 = styled.h3`
    font-size:1.2rem; 
    color:#E8175D;
    font-weight:400 !important;
    text-transform:uppercase;
    @media screen and (max-width:600px){
        font-size:0.8rem;
        margin-bottom: 1rem;
    }
`;
export const HabilitiesParr = styled.p`
    font-size:2rem;
    font-weight:400 !important;
    color:#E8175D;
    margin-top:2rem;
    margin-bottom:2rem;
    @media screen and (max-width:768px){
        text-align:center;
    }
`;